import React, { useState } from "react";
import { Button } from "@material-ui/core";
import PropTypes from "prop-types";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";

export default function ModalMessageIncomplete(props) {
  const { open, id } = props;

  const descriptionElementRef = React.useRef(null);
  React.useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);

  const scroll = "paper";

  const exit = () => {
    window.location.href = `/admin/warehouse/entry/addfile/${id}`;
  };

  return (
    <Dialog
      open={open}
      scroll={scroll}
      aria-labelledby="scroll-dialog-title"
      aria-describedby="scroll-dialog-description"
      maxWidth="sm"
      fullWidth={true}
      disableBackdropClick
    >
      <DialogTitle id="scroll-dialog-title">
        Éxito a guardar el registro
      </DialogTitle>
      <DialogContent dividers={scroll === "paper"}>
        <div className="form-row" style={{ marginBottom: "5rem" }}>
          Se guardó exitosamente el registro, pero aún no se completa el ingreso
          de guías. Podrás revisar el ingreso de guía presionando el
          botón revisar guías.
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={exit} color="primary">
          Aceptar
        </Button>
      </DialogActions>
    </Dialog>
  );
}

ModalMessageIncomplete.propTypes = {
  open: PropTypes.bool,
  message: PropTypes.string,
  id: PropTypes.string
};
